import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

//
import Moment from "react-moment";
import ScrollBar from "react-perfect-scrollbar";

//
import ImageBox from "../../general/ImageBox";

function MobileEventsList({ items, selectedCoin }) {
  return (
    <div className="box-items">
      <ScrollBar>
        {items.map((item, index) => (
          <div className="items" key={index}>
            <header className="d-flex align-items-center">
              <p className="fw-extra-bolder">{item.title}</p>
            </header>

            <div className="content">
              <div className="item">
                <small>Date Open (UTC)</small>
                <small>
                  <span className="fw-bolder text-black">
                    <Moment utc format="MMM DD, YYYY, ">{item.created_at}</Moment>
                  </span>
                  <span>
                    <Moment utc format="hh:mm">{item.created_at}</Moment>
                  </span>
                </small>
              </div>
            </div>
          </div>
        ))}
      </ScrollBar>
    </div>
  );
}

MobileEventsList.propTypes = {
  selectedCoin: PropTypes.object.isRequired,
};

export default MobileEventsList;
